import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { UsersAdmin } from "../../app/models/user";
import agent from "../../app/api/agent";

interface UsersState {
  users: UsersAdmin[],
  status: string,
  usersLoaded: boolean
}

const initialState: UsersState = {
      users: [{
          id: 0,
          userName: '',
          email: '',
          fullName: '',
          address1: '',
          address2: '',
          city: '',
          region: '',
          postCode: '',
          country: '',
          phoneNumber: '',
          }],
      status: 'idle',
      usersLoaded: false
}

export const fetchUsersAsync = createAsyncThunk<UsersAdmin[]>(
  'users/getUsers',
  async (_, thunkAPI) => {
    try {
      const response = await agent.Users.getUsers()
      return response
    } catch (error: any) {
      return thunkAPI.rejectWithValue({error: error.data})
    }
  }
)

export const UsersAdminSlice = createSlice({
  name: 'UsersAdmin',
  initialState,
  reducers: {},
  extraReducers: (builder => {
    builder.addCase(fetchUsersAsync.pending, (state, action) => {
      state.status = 'pendingFetchUsers'
    });
    builder.addCase(fetchUsersAsync.fulfilled, (state, action) => {
      state.users = action.payload
      state.status = 'idle'
      state.usersLoaded = true
    })
    builder.addCase(fetchUsersAsync.rejected, (state, action) => {
      state.status = 'idle'
      console.log(action.payload)
    })
  })

})

